import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setInviteFriendsStatus, setShowCashierPopup } from 'redux-thunk/redux/slices/settings.slice'
import CashierDeposit from './components/Deposit/index'
import CashierWithdraw from './components/Withdraw/index'
// import CashierCoupons from './components/Coupons/index'
// import CashierReferrals from './components/Referrals/index'
import CommonPopup from 'components/ui-kit/CommonPopup/index'
import NavScrollWrapper from 'components/ui-kit/NavScrollWrapper'

const TAB_IDS = {
  DEPOSIT: 'pills-cashier-deposit',
  WITHDRAW: 'pills-cashier-withdraw'
  // COUPONS: 'pills-cashier-coupons',
  // REFERRALS: 'pills-cashier-referrals'
}

const TAB_BUTTON_BASE =
  'mr-2 flex w-auto cursor-pointer items-center justify-center whitespace-nowrap rounded-[0.625rem] border border-solid border-[var(--gray-90)] bg-[var(--gray-90)] px-3 py-2 text-sm font-medium text-[var(--gray-20)] shadow-none transition-colors duration-150 hover:border-transparent hover:bg-[var(--gray-80)] hover:text-white'

const TAB_BUTTON_ACTIVE =
  'active !bg-[rgb(var(--pm-felt)/0.35)] !border-[rgb(var(--pm-gold)/0.55)] !text-[rgb(var(--pm-gold))] hover:!bg-[rgb(var(--pm-felt)/0.35)] hover:!border-[rgb(var(--pm-gold)/0.55)] hover:!text-[rgb(var(--pm-gold))] !shadow-none !transform-none'

const CashierPopup = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { inviteFriendsStatus } = useSelector(state => state.settings)
  const [activeTab, setActiveTab] = useState(TAB_IDS.DEPOSIT)

  const modalCloseHandler = () => {
    dispatch(setShowCashierPopup(false))
  }

  const cashierTabs = useMemo(() => ([
    {
      id: TAB_IDS.DEPOSIT,
      label: t('deposit'),
      Panel: CashierDeposit
    },
    {
      id: TAB_IDS.WITHDRAW,
      label: t('Withdraw'),
      Panel: CashierWithdraw
    }
    // {
    //   id: TAB_IDS.COUPONS,
    //   label: t('coupons'),
    //   Panel: CashierCoupons
    // },
    // {
    //   id: TAB_IDS.REFERRALS,
    //   label: t('referrals'),
    //   Panel: CashierReferrals
    // }
  ]), [t])

  useEffect(() => {
    return () => {
      if (inviteFriendsStatus) {
        dispatch(setInviteFriendsStatus(false))
      }
    }
  }, [])

  return (
    <CommonPopup
      classes='cashier-modal !z-[2005] min-[768px]:[&_.modal-dialog]:min-w-[805px] max-md:[&_.modal-dialog]:h-full max-lg:[&_.modal-content]:rounded-none max-lg:[&_.modal-content]:border-0 [&_.modal-content]:rounded-xl'
      modalCloseHandler={modalCloseHandler}
      id='cashierModal'
    >
      <div className='pb-4'>
        <NavScrollWrapper>
          {cashierTabs.map((tab) => {
            const isActive = activeTab === tab.id

            return (
              <li
                key={tab.id}
                className={`nav-item shrink-0 first:ml-0 [&:not(:first-child)]:ml-2 ${isActive ? 'active' : ''}`}
                role='presentation'
              >
                <button
                  className={`${TAB_BUTTON_BASE} ${isActive ? `${TAB_BUTTON_ACTIVE} active` : ''}`}
                  id={`${tab.id}-tab`}
                  type='button'
                  role='tab'
                  aria-controls={tab.id}
                  aria-selected={isActive}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </button>
              </li>
            )
          })}
        </NavScrollWrapper>
      </div>
      <div id='pills-tabContent'>
        {cashierTabs.map(({ id, Panel }) => (
          <div
            key={id}
            className={activeTab === id ? 'block' : 'hidden'}
            role='presentation'
          >
            <Panel />
          </div>
        ))}
      </div>
    </CommonPopup>
  )
}

export default CashierPopup
